export default __webpack_public_path__ + "static/media/pic6.61a0e382.jpg";